module.exports = __webpack_public_path__ + "static/media/protected.4acb94a8.svg";